import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ApiService } from '../../../lib/api.service';
import { User } from '../../../models/user';
import { Event } from '../../../models/event';
import { LogService } from '../../../lib/log.service';
import { UserService } from '../../../lib/user.service';
import { CalendarService } from '../../../lib/calendar.service';
import { ModalService } from '../../../lib/modal.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Component({
    selector: 'event-listing-component',
    templateUrl: 'event-listing.component.html',
    styleUrls: ['./event-listing.component.scss'],
    standalone: false
})


export class EventListingComponent implements OnInit {

	@Input() pickedDate: any;
	@Input() activeEvents: Event[];
	@Output() eventsChange = new EventEmitter<Object>();
	calendarStrings: any;

	user: User;

	constructor(
		private api: ApiService,
		private translate: TranslateService,
		private logService: LogService,
		private userService: UserService,
		private calendarService: CalendarService,
		private modalService: ModalService
	) {
		this.user = this.userService.getUser();
	}

	ngOnInit() {
		this.logService.debug('Active events initial fetch');
		this.logService.debug(this.activeEvents);
		this.translate.stream('calendar').subscribe((res: any) => {
			this.calendarStrings = res;
		});
	}

	removeScheduledEvent(id) {
		this.api.delete('calendar/removescheduled/' + id).subscribe(
			(results: any) => {
				let index = _.findIndex(this.activeEvents, { id: id });
				this.activeEvents.splice(index, 1);
				this.calendarService.triggerRefresh();
				this.modalService.showAlert('Success', 'Your scheduled event has been successfully removed.');
			},
			(error: any) => {
				this.modalService.showAlert('Error', error.message);
			}
		);
	}

}
